import { TableCell, TableRow, Typography } from "@material-ui/core";
import { memo } from "react";
import MaskService from "../../../../../utils/mask/maskService";

const TotalTableRow = ({ totalLabel, labelColspan, cell }) => (
  <TableRow
    style={{
      backgroundColor: cell?.total?.balance >= 0 ? "#cefad0" : "#ffcccb",
    }}
  >
    <TableCell align="left" colSpan={labelColspan}>
      <Typography
        style={{
          fontSize: "0.875rem",
        }}
      >
        {totalLabel}
      </Typography>
    </TableCell>
    <TableCell align="right">
      <Typography
        style={{
          fontSize: "0.875rem",
        }}
      >
        {`${cell?.total?.debit < 0 ? " - " : ""}  ${MaskService.toMask(
          "decimal",
          parseFloat(cell?.total?.debit ?? "0,00").toFixed(2),
          2
        )}`}
      </Typography>
    </TableCell>
    <TableCell align="right">
      <Typography
        style={{
          fontSize: "0.875rem",
        }}
      >
        {`${MaskService.toMask(
          "decimal",
          parseFloat(cell?.total?.credit ?? "0,00").toFixed(2),
          2
        )}`}
      </Typography>
    </TableCell>
    <TableCell align="right">
      <Typography
        style={{
          fontSize: "0.875rem",
        }}
      >
        {`${cell?.total?.balance < 0 ? " - " : ""} ${MaskService.toMask(
          "decimal",
          parseFloat(cell?.total?.balance ?? "0,00").toFixed(2),
          2
        )}`}
      </Typography>
    </TableCell>
  </TableRow>
);

export default memo(TotalTableRow);
